export default function Recruitment() {
  return (
    <div>
      <div className="container parent-recruitment d-flex justify-content-end align-items-center flex-column">
        <div className="parent-rec container d-flex flex-column justify-content-center align-items-center text-center">
          <div className="parent-recruit container d-flex justify-content-center">
            <div className="img-recruit">
              <img
                src={require("./Assest/recruitment/Group 48096753.png")}
                alt=""
                className=""
              />
            </div>
            <div className="text-recruit container">
              <h1>التوظيف</h1>
              <p>
                ”نهتم بالأفراد ونستثمر فيهم ونمنحهم الصلاحيات”، تلك من قيمنا
                التي نؤمن بأنها أحد أهم عناصر النجاح والتميز. إن فلسفة بيرين
                تشجع الأفراد على أخذ المبادرة والمشاركة الفاعلة بالأفكار والجهد
                وتمنحهم الثقة الكافية لتحقيق نتائج ممتازة تساهم في تحقيق الأهداف
                المشتركة
              </p>
              <p>
                فإذا كنت مهتماً في الإنضمام إلى بيئة عمل إيجابية ومحفّزة وضمن
                فريق عمل متعدد الثقافات، نرجو إرسال سيرتكم الذاتية إلى البريد
                الإلكتروني
              </p>
              <h1>info@berain.com.sa</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
